import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterSection = ({ filters, onFilterChange, onClearFilters }) => {
  const categories = [
    { id: 'all', name: 'All Departments', icon: 'Grid3X3' },
    { id: 'BCE', name: 'Building & Civil Engineering', icon: 'Cog' },
    { id: 'CIB', name: 'Computing Informatics & Business', icon: 'Monitor' },
    { id: 'EEE', name: 'Electrical & Electronics Engineering', icon: 'Zap' },
    { id: 'AES', name: 'Agriculture & Environmental Studies', icon: 'Leaf' },
    { id: 'IM', name: 'Hospitality & Toursim', icon: 'Utensils' },
    { id: 'CFD', name: 'Cosmetology & Fashion Design', icon: 'Scissors' },
  ];

  return (
    <div className="bg-card rounded-xl shadow-card p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground">Filter Departments</h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear All
        </Button>
      </div>
      <div className="space-y-6">
        {/* Category Filter */}
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3">Category</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
            {categories?.map((category) => (
              <button
                key={category?.id}
                onClick={() => onFilterChange('category', category?.id)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  filters?.category === category?.id
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
                }`}
              >
                <Icon name={category?.icon} size={16} />
                <span className="hidden sm:inline">{category?.name}</span>
              </button>
            ))}
          </div>
        </div>
        {/* Search Bar */}
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3">Search</h3>
          <div className="relative">
            <Icon
              name="Search"
              size={20}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search departments, courses, or skills..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full pl-10 pr-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;